export default function SlideShow () {

  let slideshows = document.getElementsByClassName('slideshow');

  const fn = {
      init: function (slideshow) {

        const slides = slideshow.getElementsByClassName('slideshow__slide');
        const slidesWrapper = slideshow.getElementsByClassName('slideshow__wrapper')[0];
        const slideWidth = slideshow.getElementsByClassName('slideshow__container')[0].offsetWidth;

        slidesWrapper.style.setProperty('--slide-width', `${slideWidth}px`);

        let currentSlideIndex = 0;
        let currentSlideItem = slides[currentSlideIndex];  
        currentSlideItem.classList.add('slideshow__slide--active');
        
        let slidesWrapperXPos = 0;
        slidesWrapper.style.setProperty('--horizontal-offset', `-${slidesWrapperXPos}px`);

        function scrollToSlide(goToIndex) {
          currentSlideItem.classList.remove('slideshow__slide--active');
          slides[goToIndex].classList.add('slideshow__slide--active');

          currentSlideItem = slides[goToIndex];
          currentSlideIndex = goToIndex;

          slidesWrapperXPos = currentSlideItem.offsetLeft;
          slidesWrapper.style.setProperty('--horizontal-offset', `-${slidesWrapperXPos}px`);
        }


        Array.from(slides).forEach((slide, index) => {
          slide.addEventListener('click', function handleClick(event) {
            if (index !== currentSlideIndex) {
              scrollToSlide(index);
            }
          });
        })
      }
  };

  if (slideshows.length > 0) {
    Array.from(slideshows).forEach(slideshow => {
      fn.init(slideshow);   
    })
  }
}